import _ from './underscore.js';

// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
export default _.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/templateSettings.js
// module id = 453
// module chunks = 0